import styled, { css } from "styled-components";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { colorsPalettes, mixins } from "@similarweb/styles";

export const StyledIntentSelectedTopicItemContainer = styled(FlexRow)`
    justify-content: space-between;
    width: 100%;
`;

export const StyledTopicBlock = styled(FlexRow)`
    align-items: center;
`;

export const StyledTopicName = styled.div<{ isExtraItem?: boolean }>`
    ${({ isExtraItem }) =>
        isExtraItem
            ? css`
                  ${mixins.setFontVariant("primaryItem", colorsPalettes.indigo["300"])};
              `
            : css`
                  ${mixins.setFontVariant("primaryItem", colorsPalettes.carbon["400"])};
              `}
    font-size: 13px;
    line-height: 20px;
`;

export const StyledTopicNameText = styled.span`
    margin-right: 4px;
`;

export const StyledTopicDomainCount = styled.span<{ isExtraItem?: boolean }>`
    ${({ isExtraItem }) =>
        isExtraItem
            ? css`
                  ${mixins.setFontVariant("value", colorsPalettes.indigo["200"])};
              `
            : css`
                  ${mixins.setFontVariant("value", colorsPalettes.carbon["250"])};
              `}
    font-weight: 500;
`;

export const StyledTopicRemoveBtnWrapper = styled.div`
    padding-left: 7px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const StyledTopicRemoveBtnCrossWrapper = styled(StyledTopicRemoveBtnWrapper)`
    .SWReactIcons {
        width: 9.33px;
        height: 9.33px;
    }
`;
